import React from 'react';

import FormItem from '@/components/ui/FormItem';
import Select from '@/components/ui/Select';

import { useWorkstation } from '@/components/views/Resolution886/components/Form/_hooks';
import type { FormItemProps } from '@/components/views/Resolution886/types';

interface WorkstationFormItemProps extends FormItemProps {
	fieldName?: string | string[];
}

export function WorkstationFormItem({ required = true, labelCol, fieldName }: WorkstationFormItemProps): JSX.Element {
	const { items, isFetching, isDisabled, workstationId, handleSelectWorkstation, handleClearWorkstation } =
		useWorkstation({ fieldName });

	return (
		<FormItem
			required={required}
			label="Workstation"
			name={fieldName}
			requiredMessage="Please select a workstation"
			labelCol={labelCol}
		>
			<Select
				allowClear
				options={items}
				loading={isFetching}
				value={workstationId}
				disabled={isDisabled}
				onClear={handleClearWorkstation}
				onChange={handleSelectWorkstation}
				placeholder="Select a workstation"
			/>
		</FormItem>
	);
}
